import { HttpMethod } from '@nu-art/thunderstorm-shared';
export const ApiDef_Test = {
    vv1: {
        getSignedUrl: { method: HttpMethod.POST, path: '/v1/test/signedUrl' },
    }
};
//# sourceMappingURL=apis.js.map